import { render, staticRenderFns } from "./RemoteControl.vue?vue&type=template&id=01a2c112&scoped=true&"
import script from "./RemoteControl.vue?vue&type=script&lang=js&"
export * from "./RemoteControl.vue?vue&type=script&lang=js&"
import style0 from "./RemoteControl.vue?vue&type=style&index=0&id=01a2c112&scoped=true&lang=css&"
import style1 from "./RemoteControl.vue?vue&type=style&index=1&id=01a2c112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2c112",
  null
  
)

export default component.exports